import { render } from "./edit.vue?vue&type=template&id=83a70710&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=83a70710&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-83a70710"

export default script